/**
 * @file SendWindowWarning.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-12
 * @modified 2026-10-13
 * @description A warning at the top of a transport send window (driver
 *              paperwork, the office summary) that does not stop the send —
 *              e.g. self-billed POs nobody has planned (utils/selfBilledPo).
 *              Renders nothing without a message.
 */

import React from 'react';
import './SendWindowWarning.css';

function SendWindowWarning({ message }) {
  if (!message) return null;
  return (
    <div className="send-window-warning" role="note">
      <span className="material-symbols-rounded">warning</span>
      <span>{message}</span>
    </div>
  );
}

export default SendWindowWarning;
